module.exports = __webpack_public_path__ + "img/1m2.44757b8a.jpg";